import React from 'react';
import ComingSoonPage from './componenets/ComingSoonPage';

export const DuaAndPrayers = () => {
  return <ComingSoonPage title="Dua and prayers" description="A collection of prayers and resources for remembrance, loss, and healing." image="/images/HomeSlider_9.jpg" />;
}
